export default __webpack_public_path__ + "static/media/Arm-bands of the Dark Messenger.0e12632c.jpg";